/* Additive behaviour. The prototype's app.js and motion.js are untouched. */

/* ── Hero stage: fixed device, backgrounds wiping diagonally behind it ──────
   Three layers cycle on a 3s beat. Only one is ever "in"; the outgoing layer
   is pushed off to the left so the two move together and read as one diagonal
   pane sliding across rather than a crossfade. */
;(function () {
  var layers = Array.prototype.slice.call(document.querySelectorAll('.stage-bg'))
  if (layers.length < 2) return
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    layers[0].classList.add('is-in')
    return
  }

  var i = 0
  layers[0].classList.add('is-in')

  setInterval(function () {
    var out = layers[i]
    i = (i + 1) % layers.length
    var next = layers[i]

    // park the incoming layer on the right with no transition, then release it
    next.classList.remove('is-in', 'is-out')
    void next.offsetWidth
    out.classList.remove('is-in')
    out.classList.add('is-out')
    next.classList.add('is-in')

    // once it has cleared, reset the old layer back to the right-hand start
    setTimeout(function () { out.classList.remove('is-out') }, 1200)
  }, 3000)
})()

/* ── Order-by countdown ──────────────────────────────────────────────────
   Date parts, not new Date('YYYY-MM-DD'): a bare ISO string parses as UTC
   midnight and reads a day early west of Greenwich. */
;(function () {
  var el = document.querySelector('[data-deadline]')
  if (!el) return
  var p = (el.getAttribute('data-deadline') || '').split('-')
  if (p.length !== 3) return
  var target = new Date(+p[0], +p[1] - 1, +p[2])
  if (isNaN(target.getTime())) return
  var days = el.querySelector('[data-cd-days]'), clock = el.querySelector('[data-cd-clock]')
  if (!days || !clock) return
  function pad (n) { return n < 10 ? '0' + n : String(n) }
  function render () {
    var ms = target - new Date()
    if (ms <= 0) { el.hidden = true; return }
    var t = Math.floor(ms / 1000)
    days.textContent = Math.floor(t / 86400) + 'd'
    clock.textContent = pad(Math.floor(t % 86400 / 3600)) + ':' + pad(Math.floor(t % 3600 / 60)) + ':' + pad(t % 60)
  }
  render(); setInterval(render, 1000)
})()

/* ── Model cards: each phone's notification drops in once that phone is in
   view. Hidden only after this runs, so without JS the notifications just show. */
;(function () {
  var screens = Array.prototype.slice.call(document.querySelectorAll('.tier-screen'))
  if (!screens.length || !('IntersectionObserver' in window)) return
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return
      e.target.classList.remove('is-waiting')
      io.unobserve(e.target)
    })
  }, { threshold: 0.6 })
  screens.forEach(function (s) { s.classList.add('is-waiting'); io.observe(s) })
})()

/* ── Product page: quantity stepper ──────────────────────────────────────
   The only control here — no picker, single variant per page. 0 is a real,
   reachable value (min="0" in the markup, not 1), and reaching it disables
   the buy button rather than the stepper refusing to go there; a sold-out
   button (data-sold-out) is left alone either way. */
;(function () {
  var steppers = Array.prototype.slice.call(document.querySelectorAll('.qty-stepper'))
  if (!steppers.length) return
  var MAX = 20

  steppers.forEach(function (stepper) {
    var input = stepper.querySelector('.qty-value')
    var minus = stepper.querySelector('[data-qty-step="-1"]')
    var form = stepper.closest('form')
    var buyBtn = form && form.querySelector('[data-buy-button]')

    function clamp (n) { return Math.max(0, Math.min(MAX, isNaN(n) ? 0 : n)) }

    function sync () {
      var n = clamp(parseInt(input.value, 10))
      input.value = n
      if (minus) minus.disabled = n === 0
      if (buyBtn && !buyBtn.hasAttribute('data-sold-out')) buyBtn.disabled = n === 0
    }

    stepper.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty-step]')
      if (!btn) return
      input.value = clamp(parseInt(input.value, 10) + Number(btn.dataset.qtyStep))
      sync()
    })
    input.addEventListener('input', sync)
    input.addEventListener('blur', sync)
    sync()
  })
})()

/* ── App tour ────────────────────────────────────────────────────────────
   Three phones on one stage. Whichever screen is picked comes to the front;
   the other two sit behind it, the next one on the right and the one before
   on the left, so stepping through the tabs walks around the circle. */
;(function () {
  var tabs = Array.prototype.slice.call(document.querySelectorAll('.tour-tab'))
  var phones = Array.prototype.slice.call(document.querySelectorAll('.tour-phone'))
  if (!tabs.length || phones.length !== 3) return
  var order = phones.map(function (p) { return p.dataset.screen })

  function show (key) {
    var i = order.indexOf(key)
    if (i < 0) return
    tabs.forEach(function (t) { t.setAttribute('aria-pressed', String(t.dataset.screen === key)) })
    phones.forEach(function (p, j) {
      var step = (j - i + 3) % 3
      p.dataset.pos = step === 0 ? 'front' : step === 1 ? 'right' : 'left'
    })
  }
  tabs.forEach(function (t) { t.addEventListener('click', function () { show(t.dataset.screen) }) })
  phones.forEach(function (p) { p.addEventListener('click', function () { show(p.dataset.screen) }) })
})()
